import React, { useState } from "react"
import styled from "styled-components"
import { db, fieldValue } from "../common/firebase.utils"
import { URL } from "../common/constants"
// import shareImg from "../images/share-character.png"

function Subscribe() {
  const [emailInput, setEmailInput] = useState("")
  const [pending, setPending] = useState(false)

  const isEmailValid = email => {
    return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)
  }

  const onClickSubscribe = () => {
    setPending(true)
    db.collection("subscribers")
      .doc(emailInput)
      .set({
        email: emailInput,
        subscribedat: fieldValue.serverTimestamp(),
        canceledat: null
      })
      .then(() => {
        setEmailInput("")
        setPending(false)
        alert("감사합니다!\n알림 신청이 완료되었습니다.")
      })
      .catch(e => {
        console.error("Error subscribing", e)
        setPending(false)
        alert(
          "죄송합니다. 오류가 발생했습니다.\n오류가 지속될 시 help@whattosay.kr로 문의 부탁드립니다."
        )
      })
  }

  return (
    <Section>
      <Content>
        {/* <CharacterImg src={shareImg} alt="character" /> */}
        <Title>업데이트 소식을 받아보세요</Title>
        <Description>
          뭐라고할까의 새로운 주요 소식을 이메일로 전해드려요.
          <br />
          지난 업데이트를 더 보려면{" "}
          <HistoryLink
            href={URL.HISTORY}
            target="_blank"
            rel="noopener noreferrer"
          >
            히스토리 ↗
          </HistoryLink>
        </Description>
        <FormWrapper>
          <Input
            value={emailInput}
            type="email"
            placeholder="이메일 주소를 입력해주세요"
            onChange={({ target }) => setEmailInput(target.value)}
          />
          <SubmitButton
            disabled={pending || !isEmailValid(emailInput)}
            onClick={onClickSubscribe}
          >
            {pending ? "신청 중..." : "알림 신청"}
          </SubmitButton>
          <Disclaimer>
            알림 신청 시 이메일 주소 수집 및 이메일 수신에{" "}
            <br className="md:hidden" />
            동의하는 것으로 간주됩니다.
          </Disclaimer>
        </FormWrapper>
      </Content>
    </Section>
  )
}

const Section = styled.div`
  background: #0f0e2c;
  padding: 64px 24px;

  @media (max-width: 800px) {
    padding: 48px 24px;
  }
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 480px;
  margin: 0 auto;
  text-align: center;
`

// const CharacterImg = styled.img`
//   width: 120px;
//   height: 120px;
//   object-fit: contain;
//   margin-bottom: 24px;

//   @media (max-width: 480px) {
//     width: 96px;
//     height: 96px;
//     margin-bottom: 20px;
//   }
// `

const Title = styled.h2`
  font-size: 32px;
  font-weight: 700;
  color: #ffffff;
  line-height: 130%;
  margin-bottom: 12px;

  @media (max-width: 800px) {
    font-size: 24px;
  }
`

const Description = styled.p`
  font-size: 14px;
  color: #6b7280;
  line-height: 160%;
  margin-bottom: 24px;
`

const HistoryLink = styled.a`
  color: #6b7280;
  text-decoration: underline;
  text-underline-offset: 2px;

  &:hover {
    color: #ffffff;
  }
`

const FormWrapper = styled.div`
  width: 100%;
`

const Input = styled.input`
  display: block;
  width: 100%;
  padding: 16px 20px;
  background: #1a1940;
  border: 1px solid #2d2b5a;
  border-radius: 12px;
  color: #ffffff;
  font-size: 15px;
  outline: none;
  transition: border-color 0.2s ease;

  &::placeholder {
    color: #6b7280;
  }

  &:focus {
    border-color: #5551ff;
  }
`

const SubmitButton = styled.button`
  display: block;
  width: 100%;
  padding: 16px;
  margin-top: 10px;
  background: #5551ff;
  border: none;
  border-radius: 12px;
  color: #ffffff;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover:enabled {
    background: #4340e6;
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`

const Disclaimer = styled.p`
  margin-top: 10px;
  font-size: 12px;
  color: #6b7280;
  line-height: 150%;
`

export default Subscribe
